import { render, staticRenderFns } from "./PasswordCodeSent.vue?vue&type=template&id=6ef345aa&scoped=true&"
import script from "./PasswordCodeSent.vue?vue&type=script&lang=js&"
export * from "./PasswordCodeSent.vue?vue&type=script&lang=js&"
import style0 from "./PasswordCodeSent.vue?vue&type=style&index=0&id=6ef345aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef345aa",
  null
  
)

export default component.exports